import { getProd } from '@figure/frontlib-onboarding-redux';
import * as Theme from 'shared/constants/theme';

/**
 * Gets the current theme derived from the subdomain.
 *
 * @returns {String} The current theme; defaults to Figure.
 */
export const getTheme = () => {
  /**
   * @todo Dark in production.
   * Anticipating on whitelabels being added
   */
  if (getProd()) return Theme.FIGURE;

  return Theme.FIGURE;
};

/**
 * Returns whether the app is running in localhost.  Helpful for doing some development-only actions.
 */
export const isLocalhost = () =>
  typeof window !== 'undefined' &&
  typeof window.location &&
  typeof window.location.hostname &&
  window.location.hostname.replace(/^www\./i, '') === 'localhost';
export const isTest = () =>
  typeof window !== 'undefined' &&
  typeof window.location &&
  typeof window.location.hostname &&
  window.location.hostname.replace(/^www\./i, '') === 'test.figure.com';

export const isProd = () =>
  typeof window !== 'undefined' &&
  typeof window.location &&
  typeof window.location.hostname &&
  window.location.hostname.replace(/^www\./i, '') === 'figure.com';

export const getOrigin = () => {
  const { protocol, hostname, port } = window.location;

  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
};

export const getContextUrl = () => `${getOrigin()}${process.env.PUBLIC_URL}`;
